export default function activationsService(activationsRepo) {

  'ngInject';

  this.syncRunHours = function (installationId, runHours) {
    return activationsRepo.createSyncRequest(installationId, runHours)
      .then(response => ({
        value: parseFloat(response.data[0].value)
      }));
  };
}